import React, { useState } from "react";
import { Button, Card, Form, Input, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../sources/admin.source";
import { setAdminSession } from "../auth/auth.storage";

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const data = await adminLogin(values);
      if (data.user.role !== "ADMIN" && data.user.role !== "SUPERADMIN") {
        message.error("Chỉ admin/superadmin được phép đăng nhập.");
        setLoading(false);
        return;
      }

      setAdminSession({
        token: data.access_token,
        user: {
          id: data.user._id,
          userName: data.user.username,
          coins: data.user.coins,
          role: data.user.role,
        },
      });
      navigate("/", { replace: true });
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ??
        (err?.response?.status === 401
          ? "Sai tài khoản hoặc mật khẩu"
          : "Đăng nhập thất bại");
      message.error(String(msg));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background:
          "radial-gradient(1100px 700px at 18% 12%, rgba(214,58,58,0.22), transparent 56%), radial-gradient(1000px 620px at 88% 78%, rgba(214,58,58,0.16), transparent 62%), radial-gradient(900px 520px at 50% 40%, rgba(255, 77, 79, 0.10), transparent 60%), linear-gradient(180deg, #fff3f3 0%, #f7f7f8 85%, #f7f7f8 100%)",
      }}
    >
      <Card
        style={{
          width: "min(440px, 100%)",
          borderColor: "#e6e6ea",
          background: "#ffffff",
          boxShadow: "0 18px 50px rgba(17,17,20,0.12)",
        }}
      >
        <div style={{ marginBottom: 16 }}>
          <Title level={3} style={{ margin: 0, color: "#111114" }}>
            Admin Panel
          </Title>
          <Text style={{ color: "rgba(17,17,20,0.65)" }}>
            Đăng nhập bằng tài khoản admin/superadmin
          </Text>
        </div>

        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label={<span style={{ color: "rgba(17,17,20,0.85)" }}>Username</span>}
            name="username"
            rules={[{ required: true, message: "Nhập username" }]}
          >
            <Input autoComplete="username" placeholder="admin" />
          </Form.Item>
          <Form.Item
            label={<span style={{ color: "rgba(17,17,20,0.85)" }}>Password</span>}
            name="password"
            rules={[{ required: true, message: "Nhập password" }]}
          >
            <Input.Password autoComplete="current-password" placeholder="••••••••" />
          </Form.Item>

          <Button
            htmlType="submit"
            type="primary"
            loading={loading}
            block
            style={{ fontWeight: 700 }}
          >
            Đăng nhập
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;

